import axios from 'axios'
import { PlataformaType } from '_metronic/helpers'

const API_URL = process.env.REACT_APP_API_URL
const PUSH_TOKENS_URL = `${API_URL}/notificacoes/push-tokens`

/**
 * Registra/atualiza o identificador de push deste dispositivo.
 * @param token FID (Firebase Installation ID) do navegador
 * @param plataforma Plataforma do dispositivo (default: SITE, é um app web)
 */
export const registrarPushToken = (
  token: string,
  plataforma: PlataformaType = PlataformaType.Site
): Promise<void> => {
  return axios.put(PUSH_TOKENS_URL, { token, plataforma })
}

/**
 * Revoga o token de push deste dispositivo, sem deslogar (ex: usuário desligou notificações nas configs).
 * @param token FID do navegador (ou token FCM legado, de antes da migração para FID)
 */
export const revogarPushToken = (token: string): Promise<void> => {
  return axios.delete(PUSH_TOKENS_URL, { data: { token } })
}
